export default __webpack_public_path__ + "static/media/explorandes2.c3d8519d.jpg";